import { Col, Form, Input, Modal, Row, message } from "antd";
import { useForm } from "antd/lib/form/Form";
import { leadApi } from "api/lead.api";
import React, { useImperativeHandle, useState } from "react";
import { Lead } from "types/lead";
import { ModalStatus } from "types/modal";
import { rules } from "utils/rule";

interface Props {
  onClose?: () => void;
  onSubmit?: () => void;
}

export interface ContactModal {
  handleCreate: () => void;
  handleUpdate: (data: Lead) => void;
  handleClose: () => void;
}

const { TextArea } = Input;

export const ContactModal = React.forwardRef(({ onClose, onSubmit }: Props, ref) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Partial<Lead>>({});
  const [status, setStatus] = useState<ModalStatus>("create");
  const [form] = useForm<Lead>();

  useImperativeHandle(
    ref,
    () => ({
      handleCreate,
      handleUpdate,
      handleClose,
    }),
    [],
  );

  const handleCreate = () => {
    form.resetFields();
    setData({});
    setStatus("create");
    setVisible(true);
  };

  const handleUpdate = (data: Lead) => {
    form.setFieldsValue({ ...data });
    setData(data);
    setStatus("update");
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  const onSubmitData = async () => {
    setLoading(true);
    try {
      await form.validateFields();
      // const { avatar, description, name } = form.getFieldsValue();

      // await dictionaryApi.create({
      //   dictionary: {
      //     avatar,
      //     description,
      //     name,
      //     type: DictionaryType.ReviewSample,
      //   },
      // });

      message.success("Tạo mới thành công");
      onSubmit?.();
      handleClose();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onUpdateData = async () => {
    setLoading(true);
    try {
      await form.validateFields();
      const { id, note } = form.getFieldsValue();

      await leadApi.updateNote(id, { note });

      message.success("Cập nhật thành công");
      onSubmit?.();
      handleClose();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      afterClose={() => {
        form.resetFields();
      }}
      onCancel={handleClose}
      open={visible}
      title={status == "create" ? "Thêm liên hệ" : "Cập nhật liên hệ"}
      style={{ top: 20 }}
      width={800}
      cancelText="Đóng"
      confirmLoading={loading}
      onOk={status == "create" ? onSubmitData : onUpdateData}
    >
      <Form layout="vertical" form={form}>
        <Form.Item hidden name={"id"}>
          <Input />
        </Form.Item>
        <Row>
          <Col span={24}>
            <Form.Item label="Ghi chú" name={"note"} rules={rules}>
              <TextArea rows={3} autoSize={false} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
});
